module.exports = __webpack_public_path__ + "img/23.808404a1.png";